import * as React from 'react'
import classNames from 'classnames'

export interface Props {
  /** If true will show the loading spinner without any status text/children */
  spinnerOnly?: boolean
  /** If true will show the loading spinner in the center of the parent element. The parent must be relatively positioned. */
  centerInParent?: boolean
}

const Loading: React.FC<Props> = ({
  spinnerOnly = false,
  centerInParent = false,
  children,
}) => {
  const classes = classNames('dm-loading', {
    'dm-loading__center': centerInParent,
  })

  return (
    <div className={classes}>
      <div className="dm-spinner" data-testid="spinner"></div>
      {spinnerOnly || <span>{children ?? <>Loading&hellip;</>}</span>}
    </div>
  )
}

export default Loading
